import { createTheme, mergeThemeOverrides, rem } from '@mantine/core';

import { DEFAULT_COLORS } from '../../design/definitions/defaultColors';
import tokens from '../../design/tokens';
import { convertObjectOfUnits } from '../Utils/unitConversions';
import { themeComponents } from './components';
import { variantColorResolver } from './variantColorResolver';

const convertedFontSizes = convertObjectOfUnits.toRem(tokens.fontSizes);
const convertedBreakPoints = convertObjectOfUnits.toEm(tokens.breakpoints);
const convertedSpacing = convertObjectOfUnits.toRem(tokens.spacing);
const convertedRadius = convertObjectOfUnits.toRem(tokens.radius);

// TODO: correct Theme spelling
const baseThemOverride = createTheme({
  primaryShade: {
    light: 6,
    dark: 7,
  },

  white: '#fff',
  black: '#000',

  defaultRadius: 'md',
  primaryColor: 'cobalt',
  colors: DEFAULT_COLORS,

  // focusRingStyles: {
  //   resetStyles: () => ({ outline: 'none' }),
  //   styles: {
  //     boxShadow: `none`,
  //     outline: 'none',
  //   },
  //   inputStyles: {
  //     // boxShadow: `0 0 0 1px ${theme?.colors.gray[3]}`,
  //     outline: 'none',
  //   },
  // },
  // lineHeight: 1.5,

  defaultGradient: {
    from: 'cobalt.5',
    to: 'cobalt.9',
    deg: 118,
  },

  shadows: {
    ...tokens.shadow,
    md: tokens.shadow[0], // Default Shadow
    lg: tokens.shadow[50], // Hover
    xl: tokens.shadow[100], // Shelf
  },

  fontSizes: {
    xxxs: rem(tokens.fontSizes[50]), // 10px => 50
    xxs: rem(tokens.fontSizes[100]), // 11px => 100
    xs: rem(tokens.fontSizes[200]), // 12px => 200
    sm: rem(tokens.fontSizes[300]), // 14px => 300
    md: rem(tokens.fontSizes[500]), // 16px => 500
    lg: rem(tokens.fontSizes[600]), // 18px => 600
    xl: rem(tokens.fontSizes[700]), /// 20px => 700
    xxl: rem(tokens.fontSizes[800]), /// 24px => 800
    ...convertedFontSizes,
  },

  radius: {
    xs: rem(tokens.radius[50]), // 4px
    sm: rem(tokens.radius[100]), // 8px
    md: rem(tokens.radius[200]), // 16px
    lg: rem(tokens.radius[300]), // 24px
    xl: rem(tokens.radius[400]), // 32px
    ...convertedRadius,
  },

  spacing: {
    xs: rem(tokens.spacing[100]), // 8px
    sm: rem(tokens.spacing[200]), // 12px
    md: rem(tokens.spacing[300]), // 16px
    lg: rem(tokens.spacing[400]), // 24px
    xl: rem(tokens.spacing[500]), // 32px
    ...convertedSpacing,
  },

  breakpoints: {
    xs: convertedBreakPoints[12], // Small Phone / 413px
    sm: convertedBreakPoints[25], // Phone       / 767px
    md: convertedBreakPoints[50], // Tablet      / 1023px
    lg: convertedBreakPoints[100], // Laptop      / 1279px
    xl: convertedBreakPoints[200], // Desktop     / 1365px,
    ...convertedBreakPoints,
  },
  fontFamily: 'Poppins, sans-serif',
  fontFamilyMonospace: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas',
  lineHeights: {
    xs: '1.4',
    sm: '1.45',
    md: '1.55',
    lg: '1.6',
    xl: '1.65',
  },
  headings: {
    fontFamily: 'Poppins, sans-serif',
    fontWeight: `${tokens.fontWeight[200]}`,
    sizes: {
      h1: {
        fontSize: rem(tokens.fontSizes[1000]),
        lineHeight: '1.5',
        fontWeight: `${tokens.fontWeight[200]}`,
      },
      h2: {
        fontSize: rem(tokens.fontSizes[800]),
        lineHeight: '1.5',
        fontWeight: `${tokens.fontWeight[200]}`,
      },
      h3: {
        fontSize: rem(tokens.fontSizes[700]),
        lineHeight: '1.5',
        fontWeight: `${tokens.fontWeight[200]}`,
      },
      h4: {
        fontSize: rem(tokens.fontSizes[500]),
        lineHeight: '1.5',
        fontWeight: `${tokens.fontWeight[200]}`,
      },
      h5: {
        fontSize: rem(tokens.fontSizes[400]),
        lineHeight: '1.5',
        fontWeight: `${tokens.fontWeight[200]}`,
      },
      h6: {
        fontSize: rem(tokens.fontSizes[300]),
        lineHeight: '1.5',
        fontWeight: `${tokens.fontWeight[200]}`,
      },
    },
  },
  variantColorResolver: variantColorResolver,
  other: { tokens },
  cursorType: 'pointer',
});

//TODO: correct Theme spelling
export const defaultThemOverride = mergeThemeOverrides(baseThemOverride, themeComponents);
